import classes from "../Pages.module.css";
import { Row, Col,  Skeleton, message } from "antd";
import axios from "axios";
import DataContext from "../../../Context/dataContext";
import { useState, useEffect, useContext } from "react";
import BasicDetails from "./BasicDetails";
import ItemSize from "./ItemSize";
import GradeDetails from "./GradeDetails";
import AccountDetails from "./AccountDetails";
import SyncLoader from "react-spinners/SyncLoader";
import { useNavigate } from "react-router-dom";



const identifiers = ["itemSize", "gradeDetails", "accountDetails"];

const ItemNew = (props) => {
  const employeeData = useContext(DataContext);
  const history = useNavigate();

  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(true);
  const [allData, setAllData] = useState({
    itemMaster: [
      {
        item_name: null,
        item_uom: null,
        item_category: null,
        hsn: null,
        item_group_cd: null,
        item_subgroup_code: null,
        item_rating_code: null,
        actual_name: null,
        item_min_qty: null,
        item_max_qty: null,
        reorder_level: null,
        avg_reorderqty: null,
        item_home_yn: null,
      },
    ],
    itemSize: [{ size_code: null }],
    gradeDetails: [
      {
        quality_code: null,
      },
    ],
    accountDetails: [
      {
        account_code: null,
      },
    ],
  });
  const [ad, setAD] = useState(null);

  useEffect(() => {
    setEditMode(true);
    setAD(null);
    setLoading(false);
    axios
      .get(employeeData.URL + "/api/v1/items/additional-data", {
        withCredentials: true,
      })
      .then((response) => {
        // console.log(response);
        setAD((ad) => {
          let newad = response.data.data;
          return {
            ...newad,
            ITEM_HOME_YN: {
              fields: [{ name: "KEY" }, { name: "VALUE" }],
              rows: [
                { KEY: "Y", VALUE: "YES" },
                { KEY: "N", VALUE: "NO" },
              ],
            },
          };
        });
      })
      .catch((error) => {
        // console.log(error);
      });
  }, []);

  const handleSave = (event) => {
    console.log(allData);
    if (
      allData.itemMaster[0].item_name == null &&
      allData.itemMaster[0].item_category == null &&
      allData.itemMaster[0].item_uom == null &&
      allData.itemMaster[0].hsn == null
    ) {
      // // console.log("header feilds are empty");
      message.error({
        content: "Please Fill the Mandatory Fields!!!",
        className: "custom-class",
        style: {
          marginTop: "1vh",
        },
      });

      return;
    } else if (allData.itemMaster[0].item_name == null) {
      // // console.log("header feilds are empty");
      // document.getElementById("item_nam").focus();
      // const element=document.getElementById('item_nam');
      //      element.getElementsByTagName('input')[0].focus();
      message.error({
        content: "Item name can not be null",
        className: "custom-class",
        style: {
          marginTop: "1vh",
        },
      });
      return;
    } else if (allData.itemMaster[0].item_uom == null) {
      // // console.log("header feilds are empty");
      // document.getElementById("uom").focus();
      // const element=document.getElementById('item_nam');
      //      element.getElementsByTagName('input')[0].focus();
      message.error({
        content: "Item uom can not be null",
        className: "custom-class",
        style: {
          marginTop: "1vh",
        },
      });
      return;
    } else if (allData.itemMaster[0].item_category == null) {
      // // console.log("header feilds are empty");
      // document.getElementById("item_category").focus();
      // const element=document.getElementById('item_nam');
      //      element.getElementsByTagName('input')[0].focus();
      message.error({
        content: "Item category can not be null",
        className: "custom-class",
        style: {
          marginTop: "1vh",
        },
      });
      return;
    } else if (allData.itemMaster[0].hsn == null) {
      // // console.log("header feilds are empty");
      // document.getElementById("hsn_no").focus();
      // const element=document.getElementById('item_nam');
      //      element.getElementsByTagName('input')[0].focus();
      message.error({
        content: "Hsn can not be null",
        className: "custom-class",
        style: {
          marginTop: "1vh",
        },
      });
      return;
    }
    if (!allData.itemSize.some((detail) => detail.size_code !== null)) {
      message.error({
        content: "Please fill  at least one Size in the Item Size Detail!",
        className: "custom-class",
        style: {
          marginTop: "1vh",
        },
      });
      return; // Prevent the save operation
    }

    if (!allData.gradeDetails.some((detail) => detail.quality_code !== null)) {
      message.error({
        content: "Please fill at least one Grade  in the Item Grade Details!",
        className: "custom-class",
        style: {
          marginTop: "1vh",
        },
      });
      return; // Prevent the save operation
    }

    if (
      !allData.accountDetails.some((detail) => detail.account_code !== null)
    ) {
      message.error({
        content:
          "Please fill  at least one account  in the Account Detail tab!",
        className: "custom-class",
        style: {
          marginTop: "1vh",
        },
      });
      return; // Prevent the save operation
    }

    var formv = true;

    identifiers.forEach((val) => {
      let count = 0;
      allData[val].forEach((data) => {
        // console.log(!data);
        // console.log(!data);
        // console.log(!data);
        if (!data) {
          formv = formv && false;
          if (count === 0) {
            message.error({
              content: "Empty Fields In " + val.toUpperCase() + " Tab!!!",
              className: "custom-class",
              style: {
                marginTop: "1vh",
              },
            });
          }

          count = count + 1;
        }
      });
    });

    if (formv) {
      setLoading(true);
      const postData = {
        ...allData,
        itemSize: allData.itemSize.map((dep) => {
          return {
            ...dep,
          };
        }),
        gradeDetails: allData.gradeDetails.map((dep) => {
          return {
            ...dep,
          };
        }),
        accountDetails: allData.accountDetails.map((dep) => {
          return {
            ...dep,
          };
        }),
      };

      // Helper function to remove duplicates based on a key
      const removeDuplicates = (array, key) => {
        return array.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t[key] === value[key])
        );
      };

      // Check if the arrays exist and remove duplicates where applicable
      if (Array.isArray(postData.accountDetails)) {
        postData.accountDetails = removeDuplicates(
          postData.accountDetails,
          "account_code"
        );
      }

      if (Array.isArray(postData.gradeDetails)) {
        postData.gradeDetails = removeDuplicates(
          postData.gradeDetails,
          "quality_code"
        );
      }

      if (Array.isArray(postData.itemSize)) {
        postData.itemSize = removeDuplicates(postData.itemSize, "size_code");
      }
      console.log(postData);

      axios
        .post(employeeData.URL + "/api/v1/items", postData, {
          withCredentials: true,
          credentials: "include",
        })

        .then((response) => {
          if (response.data.status === "fail") {
            message.error({
              content: response.data.message,
              className: "custom-class",
              style: {
                marginTop: "2vh",
              },
            });

            setLoading(false);
          } else {
            message.success({
              content: "item master Created Successfully!!!",
              className: "custom-class",
              style: {
                marginTop: "2vh",
              },
            });
            setLoading(false);
            history("/sales/itemMaster/item-details");
          }
        })

        .catch((err) => {
          // if(response.data.status === 'fail'){
          //     message.error({
          //         content: response.data.message,
          //         className: 'custom-class',
          //         style: {
          //             marginTop: '2vh',
          //         },
          //     });

          //     setLoading(false)
          // }
          message.error({
            content: "An Error Occurred!!!!",
            className: "custom-class",
            style: {
              marginTop: "2vh",
            },
          });
          setLoading(false);
        });
    }
  };

  const handleCancel = (event) => {
    setLoading(false);
    history("/sales/itemMaster/item-details");
  };

  return (
    <>
      {ad ? (
        <Row className={classes["RowP"]}>
          <Col
            lg={editMode ? 13 : 19}
            md={editMode ? 13 : 19}
            className={classes["Col"]}
          ></Col>
          {editMode ? (
            <>
              <Col md={4}>
                {loading ? (
                  <SyncLoader color={"rgba(255,163,77,0.8)"} size={10} />
                ) : (
                  <button
                    style={{
                      padding: "7px 30px 14px 24px",
                      borderRadius: "50px",
                      background: "transparent",
                      width: "100%",
                      border: "none",
                      outline: "none",
                      fontSize: "16px",
                      fontWeight: "600",
                      lineHeight: "1.5",
                      color: "#071e54",
                      WebkitAppearance: "none",

                      boxShadow:
                        "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff", // Original box shadow
                      height: "40px",

                      // Ensure the button takes full width
                    }}
                    onClick={(event) => handleSave(event)}
                    className={classes["ProfileButtonn"]}
                    id="save"
                    onMouseOver={(event) => {
                      event.target.style.boxShadow = "0px 5px 15px 0px #264a9f"; // Apply spread color on hover with 0 spread at the top
                    }}
                    onMouseOut={(event) => {
                      event.target.style.boxShadow =
                        "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff"; // Restore original shadow on mouse out
                    }}
                  >
                    Save
                  </button>
                )}
              </Col>
              <Col md={4}>
                {loading ? (
                  <SyncLoader color={"rgba(255,163,77,0.8)"} size={10} />
                ) : (
                  <button
                    style={{
                      padding: "7px 30px 14px 24px",
                      borderRadius: "50px",
                      background: "transparent",
                      width: "100%",
                      border: "none",
                      outline: "none",
                      fontSize: "16px",
                      fontWeight: "600",
                      lineHeight: "1.5",
                      color: "#071e54",
                      WebkitAppearance: "none",

                      boxShadow:
                        "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff", // Original box shadow
                      height: "40px",

                      // Ensure the button takes full width
                    }}
                    onClick={(event) => handleCancel(event)}
                    onMouseOver={(event) => {
                      event.target.style.boxShadow = "0px 5px 15px 0px #264a9f"; // Apply spread color on hover with 0 spread at the top
                    }}
                    onMouseOut={(event) => {
                      event.target.style.boxShadow =
                        "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff"; // Restore original shadow on mouse out
                    }}
                    className={classes["ProfileButtonn"]}
                  >
                    Cancel
                  </button>
                )}
              </Col>
            </>
          ) : (
            <Col md={4}>
              <button
                onClick={() => setEditMode(true)}
                className={classes["ProfileButton"]}
              >
                Edit Details
              </button>
            </Col>
          )}

          <Col lg={24} md={24} className={classes["Col"]}>
            <div style={{ textAlign: "center" }}>
              <h3
                style={{
                  display: "inline-block",
                  padding: "10px 20px",
                  borderRadius: "5px 5px 0 0",
                  backgroundColor: "white",
                  // border: "0.5px solid #d9d9d9",
                  color: "#1560BD",
                  fontSize: "14px",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                Item Master
              </h3>
            </div>
            <BasicDetails
              create={true}
              ad={ad}
              setData={setAllData}
              data={allData.itemMaster[0]}
              editMode={editMode}
            />

            <Row style={{ width: "100%" }}>
              <Col
                lg={8}
                style={{
                  paddingLeft: "40px",
                }}
              >
                <div style={{ textAlign: "left" }}>
                  <h3
                    style={{
                      display: "inline-block",
                      // padding: "10px 20px",
                      borderRadius: "5px 5px 0 0",
                      backgroundColor: "white",
                      // border: "0.5px solid #d9d9d9",
                      color: "#1560BD",
                      fontSize: "14px",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  >
                    Item Size Detail
                  </h3>
                </div>

                <ItemSize
                  ad={ad}
                  setData={setAllData}
                  data={allData.itemSize}
                  editMode={editMode}
                />
              </Col>
              <Col
                lg={8}
                style={{
                  paddingLeft: "20px",
                }}
              >
                <div style={{ textAlign: "left" }}>
                  <h3
                    style={{
                      display: "inline-block",
                      // padding: "10px 20px",
                      borderRadius: "5px 5px 0 0",
                      backgroundColor: "white",
                      // border: "0.5px solid #d9d9d9",
                      color: "#1560BD",
                      fontSize: "14px",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  >
                    Item Grade Details
                  </h3>
                </div>

                <GradeDetails
                  ad={ad}
                  setData={setAllData}
                  data={allData.gradeDetails}
                  editMode={editMode}
                />
              </Col>
              <Col
                lg={8}
                style={{
                  paddingLeft: "20px",
                }}
              >
                <div style={{ textAlign: "left" }}>
                  <h3
                    style={{
                      display: "inline-block",
                      // padding: "10px 20px",
                      borderRadius: "5px 5px 0 0",
                      backgroundColor: "white",
                      // border: "0.5px solid #d9d9d9",
                      color: "#1560BD",
                      fontSize: "14px",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  >
                    Account Details
                  </h3>
                </div>

                <AccountDetails
                  ad={ad}
                  setData={setAllData}
                  data={allData.accountDetails}
                  editMode={editMode}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      ) : (
        <>
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
        </>
      )}
    </>
  );
};

export default ItemNew;
